import React from 'react'

export default function Commenter({item, onCommentSave}) {

	function handleSubmit() {
		const comment = document.querySelector("#hb-comment").value;
		onCommentSave(item, comment);
	}

	return (
		<form
			onSubmit={handleSubmit}
			className="comment"
			onClick={(e) => { e.stopPropagation(); e.preventDefault(); }}
		>
			<textarea rows="5" id="hb-comment" defaultValue={item.message || ""} />
			<input type="submit" onClick={handleSubmit} value="Save" />
		</form>
	);
};


// WEBPACK FOOTER //
// ./src/widgets/commenter.jsx